import { Box, designTokens } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledCartBadge = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 2,
  right: 0,
  width: 8,
  height: 8,
  backgroundColor: designTokens.colors.red[500],
  outline: `3px solid ${theme.palette.background.paper}`,
  borderRadius: '100%',
}));
